import { createAsyncThunk } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { postUpdateAdditionalWork } from '../services/postUpdateAdditionalWork.service';

const statusTimestampFieldMap = {
  PENDING: 'createdAt',
  ORDERED: 'orderedAt',
  CAN_BE_INVOICED: 'canBeInvoicedAt',
  INVOICED: 'invoicedAt',
  CANCELLED: 'cancelledAt',
};

export const updateAdditionalWork = createAsyncThunk(
  'expenseTracking/updateAdditionalWork',
  async (additionalWorkData, { getState }) => {
    const selectedProjectId = selectSelectedProjectId(getState());

    if (!selectedProjectId) {
      throw new Error('No project id given');
    }

    if (!additionalWorkData?.id) {
      throw new Error('No additional work id given');
    }

    const status = additionalWorkData?.status || 'PENDING';
    const statusTimestampField = statusTimestampFieldMap[status];
    const now = dayjs().toISOString();

    const payload = {
      ...additionalWorkData,
      ...(statusTimestampField ? { [statusTimestampField]: now } : {}),
    };

    const updatedAdditionalWork = await postUpdateAdditionalWork(
      selectedProjectId,
      additionalWorkData.id,
      payload
    );

    return updatedAdditionalWork;
  }
);
